import React from 'react';
import './App.css';
import { HashRouter, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Experience from './pages/Experience';
import Writing from './pages/Writing';
import Growth from './pages/Growth';
import Credentials from './pages/Credentials';
import Contact from './pages/Contact';
import Article from './pages/Article';

function App() {
  return (
    <ThemeProvider>
      <div className="App min-h-screen bg-background text-foreground grain relative">
        <HashRouter>
          <Header />
          <main className="relative z-10">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/experience" element={<Experience />} />
              <Route path="/writing" element={<Writing />} />
              <Route path="/writing/:slug" element={<Article />} />
              <Route path="/growth" element={<Growth />} />
              <Route path="/credentials" element={<Credentials />} />
              <Route path="/contact" element={<Contact />} />
            </Routes>
          </main>
          <Footer />
        </HashRouter>
      </div>
    </ThemeProvider>
  );
}

export default App;
